// extracted by mini-css-extract-plugin
export default {"container":"Orders_container__tYeQB","orders_container":"Orders_orders_container__zHe5r"};